import { CAPACITY_UTILISATION, DOWNLOAD_CAPACITY_DATA } from 'actions/dataReport';
import { call, put, takeLatest } from 'redux-saga/effects';
import { API } from '../api';

function* getCapacityUtilisation(action) {
  try {
    const response = yield call(API.getCapacityUtilisation, action.payload);
    yield put({ type: CAPACITY_UTILISATION.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: CAPACITY_UTILISATION.FAIL, payload: { error: e } });
    action.cb && action.cb(e);
  }
}

function* downloadCapacityUtilisation(action) {
  try {
    const response = yield call(API.downloadCapacityUtilisation, action.payload);
    yield put({ type: DOWNLOAD_CAPACITY_DATA.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: DOWNLOAD_CAPACITY_DATA.ERROR, payload: { error: e } });
    action.cb && action.cb(e);
  }
}

function* capacityUtilisation() {
  yield takeLatest(CAPACITY_UTILISATION.REQUEST, getCapacityUtilisation);
  yield takeLatest(DOWNLOAD_CAPACITY_DATA.REQUEST, downloadCapacityUtilisation);
}
export default capacityUtilisation;
